const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="presentation" aria-hidden="true"><path d="M3.751 12q.001-.166.065-.306l.123-.19.032-.035L11.22 4.22a.751.751 0 1 1 1.062 1.062L6.316 11.25h12.933a.751.751 0 0 1 0 1.502H6.316l5.966 5.967a.751.751 0 0 1-1.062 1.062l-7.249-7.249-.002-.002a.75.75 0 0 1-.218-.53"/></svg>';
export {
  a as w
};
